/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fill-more': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd"><circle pid="0" cx="16" cy="12" r="1"/><circle pid="1" cx="16" cy="17" r="1"/><circle pid="2" cx="16" cy="22" r="1"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/fill-more.js